module.exports = __webpack_public_path__ + "img/CMM.e6552312.svg";